import sanitizeHtml from 'sanitize-html';

const STYLE_ONLY_SANITIZE_HTML_CONFIG = {
  allowedTags: ['br', 'strong', 'em', 'u', 'div', 'span', 'ul', 'li'],
  allowedAttributes: {
    div: ['class'],
    span: ['class']
  }
};

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['a', ...STYLE_ONLY_SANITIZE_HTML_CONFIG.allowedTags],
  allowedAttributes: {
    ...STYLE_ONLY_SANITIZE_HTML_CONFIG.allowedAttributes,
    a: ['href', 'target', 'rel', 'class']
  }
};

export function styleOnlySanitizeGenericHtml(code: string): string {
  return sanitizeHtml(code, STYLE_ONLY_SANITIZE_HTML_CONFIG);
}

export function sanitizeGenericHtml(code: string): string {
  return sanitizeHtml(code, SANITIZE_HTML_CONFIG);
}
